import dayjs from 'dayjs';
import { formatMoney, formatNumber } from '@/utils/format';
import type { ReportCellKind, ReportCellValue, ReportColumn } from '@/services/reportDocuments.service';

export function formatReportCell(value: ReportCellValue | undefined, kind: ReportCellKind = 'text'): string {
  if (value === null || value === undefined || value === '') return '';
  const n = Number(value);
  switch (kind) {
    case 'money':
      return Number.isFinite(n) ? formatMoney(Math.abs(n) < 0.005 ? 0 : n, { display: 'plain', locale: 'en-US' }) : String(value);
    case 'number':
      return Number.isFinite(n) ? formatNumber(n, { locale: 'en-US', maximumFractionDigits: 2 }) : String(value);
    case 'percent':
      return Number.isFinite(n) ? `${formatNumber(n, { locale: 'en-US', minimumFractionDigits: 1, maximumFractionDigits: 1 })}%` : String(value);
    case 'date':
      return dayjs(String(value)).isValid() ? dayjs(String(value)).format('DD-MM-YYYY') : String(value);
    case 'image':
      return '';
    default:
      return String(value);
  }
}

export function reportColumnAlign(c: ReportColumn): 'left' | 'right' | 'center' {
  if (c.align) return c.align;
  if (c.kind === 'image') return 'center';
  return c.kind === 'money' || c.kind === 'number' || c.kind === 'percent' ? 'right' : 'left';
}
